<template>
    <div :style="{'height':clientHeight-90+'px'}">
            <div >
                <div class="m-portlet m-b-10">
                    <div class="m-portlet__body">
                        <el-form>
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <el-form-item label="日期">
                                        <el-date-picker
                                                v-model="filter.date"
                                                type="date"
                                                :clearable="false"
                                                value-format="yyyy-MM-dd"
                                                placeholder="选择日期"
                                                @change="handleShow()">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="展示方式">
                                        <el-select v-model="filter.show_type" placeholder="请选择展示方式"
                                                   @change="handleShow()" style="width: 160px">
                                            <el-option
                                                    v-for="item in show_types"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="筛选">
                                        <el-select v-model="filter.specialChoose"
                                                   multiple
                                                   clearable
                                                   placeholder="请选择"
                                                   @change="handleShow()" style="width: 160px">
                                            <el-option
                                                    v-for="item in specialTypes"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </div>


                <div class="m-portlet m-b-10" :style="{'height':(clientHeight-250)+'px'}" v-loading="loading">
                        <div class="m-portlet__body" v-if="filter.show_type==1">
                            <el-table
                                    :data="tableData"
                                    :span-method="objectSpanMethod"
                                    border
                                    ref="subject"
                                    :summary-method="getSummaries"
                                    show-summary
                                    :cell-class-name="cellStyle"
                                    :height="clientHeight-280"
                                    style="width: 100%">
                                <el-table-column
                                        prop="section_name"
                                        align="center"
                                        label="校区"
                                        min-width="8%">
                                </el-table-column>
                                <el-table-column
                                        prop="time"
                                        label="时间"
                                        align="center"
                                        min-width="10%">
                                </el-table-column>
                                <el-table-column label="语文" align="center" min-width="10%">
                                    <el-table-column
                                            prop="chinese_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="chinese_student_count"
                                            align="center"
                                            style="color: blue"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="数学" align="center" min-width="10%">
                                    <el-table-column
                                            prop="math_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="math_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="英语" align="center" min-width="10%">
                                    <el-table-column
                                            prop="english_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="english_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="物理" align="center" min-width="10%">
                                    <el-table-column
                                            prop="physical_classPlan_count"
                                            label="课数"
                                            align="center"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="physical_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="化学" align="center"  min-width="10%">
                                    <el-table-column
                                            prop="chemical_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="chemical_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="历史" align="center" min-width="10%">
                                    <el-table-column
                                            prop="history_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="history_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="地理" min-width="10%" align="center">
                                    <el-table-column
                                            prop="geographic_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="geographic_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="生物" min-width="10%" align="center">
                                    <el-table-column
                                            prop="biological_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="biological_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="政治" min-width="10%" align="center">
                                    <el-table-column
                                            prop="political_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="political_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="合计" min-width="10%" align="center">
                                    <el-table-column
                                            prop="all_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="all_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="m-portlet__body" v-if="filter.show_type==2">
                            <el-table
                                    :data="tableData"
                                    :span-method="objectSpanMethod"
                                    border
                                    show-summary
                                    ref="grade"
                                    :cell-class-name="cellStyle"
                                    :height="clientHeight-280"
                                    style="width: 100%">
                                <el-table-column
                                        prop="section_name"
                                        label="校区"
                                        align="center"
                                        min-width="8%">
                                </el-table-column>
                                <el-table-column
                                        prop="time"
                                        label="时间"
                                        align="center"
                                        min-width="10%">
                                </el-table-column>
                                <el-table-column label="预初" min-width="8%" align="center">
                                    <el-table-column
                                            prop="preliminary_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="preliminary_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="初一" min-width="8%" align="center">
                                    <el-table-column
                                            prop="juniorFirst_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="juniorFirst_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="初二" min-width="8%" align="center">
                                    <el-table-column
                                            prop="juniorSecond_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="juniorSecond_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="初三" min-width="8%" align="center">
                                    <el-table-column
                                            prop="juniorThird_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="juniorThird_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="高一" min-width="8%" align="center">
                                    <el-table-column
                                            prop="highFirst_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="highFirst_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="高二" min-width="8%" align="center">
                                    <el-table-column
                                            prop="highSecond_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="highSecond_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="高三" min-width="8%" align="center">
                                    <el-table-column
                                            prop="highThird_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="highThird_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column label="合计" min-width="8%" align="center">
                                    <el-table-column
                                            prop="all_classPlan_count"
                                            align="center"
                                            label="课数"
                                            min-width="5%">
                                    </el-table-column>
                                    <el-table-column
                                            prop="all_student_count"
                                            align="center"
                                            label="人数"
                                            min-width="5%">
                                    </el-table-column>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
            </div>
    </div>
</template>

<script>
    export default {
        name: 'Invoice-list',
        data() {
            return {
                path: "/anlyDashboard/templateTimeStudent",
                loading: false,
                search_loading: true,
                filter:{
                    date:this.$moment().format('YYYY-MM-DD'),
                    show_type:1,
                    specialChoose:[],
                },
                show_types:[
                    {
                        id:1,
                        name:'学科'
                    },
                    {
                        id:2,
                        name:'年级'
                    }
                ],
                specialTypes:[
                    {
                        value: '1',
                        label: '正常'
                    },
                    {
                        value: '2',
                        label: '试听'
                    },
                    {
                        value: '3',
                        label: '购物车'
                    }
                ],
                tableData: []
            }
        },
        created() {
            this.handleCreate();
            this.handleShow();
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {


            handleCreate() {
                //建立webSocket链接
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleData(event, data) {
                switch (event) {
                    case 'init':
                        this.payment_types = data.payment_types;
                        this.sections = data.sections;
                        break;
                    case 'list':
                        this.tableData=data
                        setTimeout(()=>{
                            if(this.filter.show_type==1){
                                this.$refs.subject.doLayout()
                            }else{
                                this.$refs.grade.doLayout()
                            }
                        },100)
                        this.loading=false;
                        break;
                }
            },
            handleShow(){
                this.loading=true;
                this.$wApi.send(this.path, 'list',{
                    'date':this.filter.date,
                    'show_type':this.filter.show_type,
                    'specialChoose':this.filter.specialChoose,
                });
            },
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0) {
                    return {
                        rowspan: row.rowspan,
                        colspan: row.colspan
                    };

                }
            },
            cellStyle({row, column, rowIndex, columnIndex}){
                if(columnIndex > 1 && columnIndex%2==0){
                    return 'warning-row';
                }
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    if (index === 1) {
                        sums[index] = '';
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] =sums[index]/2 ;
                    } else {
                        sums[index] = 'N/A';
                    }
                });

                return sums;
            }
        }
    }
</script>

<style>
    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .success-row {
        background: blue;
    }
</style>
